import api from "@/config/apiConfig";

class IssuesController {
  async index(params = {}) {
    try {
      const response = await api.get("/issues", { params });
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.index: ", error);
      throw error;
    }
  }

  async findAllStatuses(departmentId) {
    try {
      const response = await api.get("/issues/statuses", { params: { departmentId } });
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.findAllStatuses: ", error);
      throw error;
    }
  }

  async createStatus(data) {
    try {
      const response = await api.post("/issues/statuses", data);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.createStatus: ", error);
      throw error;
    }
  }

  async updateStatus(id, data) {
    try {
      const response = await api.patch(`/issues/statuses/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.updateStatus: ", error);
      throw error;
    }
  }

  async deleteStatus(id, moveToStatusId) {
    try {
      const response = await api.delete(`/issues/statuses/${id}`, { params: moveToStatusId ? { moveToStatusId } : {} });
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.deleteStatus: ", error);
      throw error;
    }
  }

  async reorderStatuses(departmentId, statusIds) {
    try {
      const response = await api.patch("/issues/statuses/reorder", { departmentId, statusIds });
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.reorderStatuses: ", error);
      throw error;
    }
  }

  async getOne(id) {
    try {
      const response = await api.get(`/issues/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.getOne: ", error);
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await api.post("/issues", data);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.create: ", error);
      throw error;
    }
  }

  async update(id, data) {
    try {
      const response = await api.patch(`/issues/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.update: ", error);
      throw error;
    }
  }

  async updatePositions(statusId, issueIds) {
    try {
      const response = await api.patch("/issues/positions", { statusId, issueIds });
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.updatePositions: ", error);
      throw error;
    }
  }

  async uploadAttachment(issueId, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await api.post(`/issues/${issueId}/attachments`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.uploadAttachment: ", error);
      throw error;
    }
  }

  async deleteAttachment(attachmentId) {
    try {
      const response = await api.delete(`/issues/attachments/${attachmentId}`);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.deleteAttachment: ", error);
      throw error;
    }
  }

  async remove(id) {
    try {
      const response = await api.delete(`/issues/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.remove: ", error);
      throw error;
    }
  }

  async addComment(issueId, data) {
    try {
      const response = await api.post(`/issues/${issueId}/comments`, data);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.addComment: ", error);
      throw error;
    }
  }

  async updateComment(commentId, message) {
    try {
      const response = await api.patch(`/issues/comments/${commentId}`, { message });
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.updateComment: ", error);
      throw error;
    }
  }

  async deleteComment(commentId) {
    try {
      const response = await api.delete(`/issues/comments/${commentId}`);
      return response.data;
    } catch (error) {
      console.error("Erro no IssuesController.deleteComment: ", error);
      throw error;
    }
  }
}

export default new IssuesController();
